import { render } from "./ReferralBindingsManagement.vue?vue&type=template&id=5626e637&scoped=true"
import script from "./ReferralBindingsManagement.vue?vue&type=script&lang=js"
export * from "./ReferralBindingsManagement.vue?vue&type=script&lang=js"

import "./ReferralBindingsManagement.vue?vue&type=style&index=0&id=5626e637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5626e637"]])

export default __exports__